import MacleJSBridge from 'src/bridges';
import { APINames } from 'src/shared';
import { GeneralInvokeOption } from 'src/types';

// 获取网络类型
export function getNetworkType(option?: GeneralInvokeOption) {
  return MacleJSBridge.beforeInvoke(APINames.Native.GET_NETWORK_TYPE, option);
}
